<template>
  <div>
    <base-modal :show="showModal" @close="handleClose" @save="save">
      <template v-slot:header> User </template>
      <template v-slot:main>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <base-label>Name</base-label>
            <base-input v-model="user.name" />
          </div>
          <div>
            <base-label>Email</base-label>
            <base-input v-model="user.email" />
          </div>
          <div>
            <base-label>Password</base-label>
            <base-input v-model="user.password"></base-input>
          </div>
          <div v-if="outfitters.length">
            <base-label>Outfitter</base-label>
            <el-select
              v-model="user.outfitter_id"
              placeholder="Select"
              class="w-full"
              clearable
            >
              <el-option
                v-for="outfitter in outfitters"
                :key="outfitter.id"
                :label="outfitter.name"
                :value="outfitter.id"

              >
              </el-option>
            </el-select>
          </div>
          <div>
            <base-label>Role</base-label>
            <el-select v-model="user.role" placeholder="Select" class="w-full">
              <el-option
                v-for="(item, index) in roles"
                :key="index"
                :label="item | capitalize"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div v-if="user.role === 'admin' || user.role === 'outfitter'">
            <base-label>Is Photographer</base-label>
            <el-select
              v-model="user.is_photographer"
              placeholder="Select"
              class="w-full"
            >
              <el-option key="yes" label="Yes" value="Yes"> </el-option>
              <el-option key="no" label="No" value="No"> </el-option>
            </el-select>
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import Validator from "../common/Validator";
const clone = require("lodash/cloneDeep");
import BaseModal from "@/components/ui/elements/BaseModal";
import { Notification } from "element-ui";

export default {
  name: "User",
  props: {
    user: Object,
    showModal: {
      type: Boolean,
      default: false,
    },
    outfitterId: String,
  },
  components: { BaseModal },
  data() {
    return {
      userData: {
        id: null,
        name: "",
        email: "",
        password: "",
        role: "",
        outfitter_id: null,
        is_photographer: "No",
      },
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    save() {
      if (this.userData.id) {
        if (
          !Validator([
            { field: this.userData.name, name: "User Name" },
            { field: this.userData.email, name: "User Email" },
          ])
        ) {
          return;
        }
      } else {
        if (
          !Validator([
            { field: this.userData.name, name: "User Name" },
            { field: this.userData.email, name: "User Email" },
            { field: this.userData.password, name: "User Password" },
          ])
        ) {
          return;
        }
      }

      if (this.userData.role == "Outfitter" && !this.userData.outfitter_id) {
        Notification({
          title: "Oops",
          message:
            "Outfitter role has been selected but no outfitter was selected",
          type: "warning",
          duration: 6000,
        });
        return;
      }

      if (this.userData.role == "Employee" && !this.userData.outfitter_id) {
        Notification({
          title: "Oops",
          message:
            "Employee role has been selected but no outfitter was selected",
          type: "warning",
          duration: 6000,
        });
        return;
      }
      this.userData.is_photographer =
        this.userData.is_photographer === "Yes" ? 1 : 0;

      this.$store.dispatch("user/save_user", this.userData).then((resp) => {
        if (!resp.success) return;

        this.$emit("saved");
      });
    },
  },
  computed: {
    outfitters: function () {
      let outfitters = this.$store.getters["outfitter/getOutfitters"];
      if (
        !this.outfitterId &&
        this.loggedInUser &&
        this.loggedInUser.role === "admin"
      ) {
        return outfitters;
      }

      return [];
    },
    loggedInUser: function () {
      return this.$store.getters["auth/getUser"];
    },
    roles: function () {
      if (
        !this.outfitterId &&
        this.loggedInUser &&
        this.loggedInUser.role === "admin"
      ) {
        return ["Admin", "Outfitter", "Employee", "Photographer"];
      }
      return ["Outfitter", "Employee", "Photographer"];
    },
  },
  mounted() {
    this.$store.dispatch("outfitter/all", { withDeleted: 0 });
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.userData = clone(newValue);
      },
    },
  },
};
</script>
